import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TrialLinkStatus } from '@app/+state/trials/trials.model';
import { canManageTenant } from '@app/v2/shared/utils';
import { EntitlementStatus, UserDataFacade } from '@ra-state';
import {
  ITooltipConfig,
  OutlinedButtonComponent,
  TooltipDirective,
  TooltipPosition,
} from '@ra-web-tech-ui-toolkit/components';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { tap } from 'rxjs';

@Component({
  selector: 'app-ag-allocate-btn',
  templateUrl: './ag-allocate-btn.component.html',
  styleUrls: ['./ag-allocate-btn.component.scss'],
  imports: [TooltipDirective, OutlinedButtonComponent, AsyncPipe],
})
export class AgAllocateBtnComponent implements ICellRendererAngularComp {
  private readonly userDataFacade = inject(UserDataFacade);

  readonly tooltipConfig: ITooltipConfig = { position: TooltipPosition.Top, maxWidth: 400 };
  readonly tooltipConfigNewUser: ITooltipConfig = { position: TooltipPosition.Left, maxWidth: 200 };
  readonly tooltipConfigServiceUser: ITooltipConfig = { position: TooltipPosition.Left, maxWidth: 215 };
  ENTITLEMENT_STATUS = EntitlementStatus;
  TRIAL_LINK_STATUS = TrialLinkStatus;
  personalTenantUserToolTip: string =
    'Create or join an organization in order to allocate your entitlements or trials.';
  navigatorOrContributorToolTip: string =
    'You don’t have permission to allocate to this organization. Contact your administrator.';
  private params: any;
  isTrial: boolean;

  canManageTenant: boolean = false;
  canManageTenant$ = this.userDataFacade.manageableResources$.pipe(
    tap((resources) => {
      this.canManageTenant = canManageTenant(resources);
    }),
  );

  isTenantSelected: boolean = false;
  selectedTenant$ = this.userDataFacade.selectedTenant$.pipe(
    tap((selectedTenant) => {
      if (selectedTenant) {
        this.isTenantSelected = true;
      }
    }),
  );

  refresh(_params: ICellRendererParams): boolean {
    return true;
  }

  agInit(params: any): void {
    this.params = params;
    this.isTrial = this.params['isTrial'] || false;
  }

  btnClickedHandler(_event?: any): void {
    this.params.clicked(this.params.data);
  }

  get Status(): EntitlementStatus {
    return this.params?.data.status;
  }

  get TrialLinkStatus(): TrialLinkStatus {
    return this.params?.data.status;
  }

  get Disabled(): boolean {
    return !this.isTenantSelected || this.canManageTenant === false;
  }

  get AllocateToolTip(): string {
    if (!this.isTenantSelected) {
      return this.personalTenantUserToolTip;
    } else if (this.canManageTenant === false) {
      return this.navigatorOrContributorToolTip;
    } else {
      return '';
    }
  }

  get AllocateTooltipConfig(): ITooltipConfig {
    if (!this.isTenantSelected) {
      return this.tooltipConfigNewUser;
    } else if (this.canManageTenant === false) {
      return this.tooltipConfigServiceUser;
    } else {
      return { position: TooltipPosition.Left, maxWidth: 200 };
    }
  }
}
